export const NO_INBOUND_TRANSITIONS_TO_STATUS = 'NO_INBOUND_TRANSITIONS_TO_STATUS';
export const NON_UNIQUE_STATUS_NAME = 'NON_UNIQUE_STATUS_NAME';
export const VERSION_CONFLICT = 'VERSION_CONFLICT';
export const OLD_STATUS_MISSING_IN_ORIGINAL_WORKFLOW = 'OLD_STATUS_MISSING_IN_ORIGINAL_WORKFLOW';
export const NEW_STATUS_IN_MAPPING_MISSING_IN_WORKFLOW =
	'NEW_STATUS_IN_MAPPING_MISSING_IN_WORKFLOW';
export const ONLY_ONE_INITIAL_TRANSITION_ALLOWED = 'ONLY_ONE_INITIAL_TRANSITION_ALLOWED';
export const APPROVAL_RULE_MISCONFIGURED = 'APPROVAL_RULE_MISCONFIGURED';
